import { baseQuery } from '../baseQuery';

type PutTechNotesParams = {
  jobId: string;
  technicianNote: string;
};

export const putTechNotes = async ({
  jobId,
  technicianNote,
}: PutTechNotesParams) => {
  const { data } = await baseQuery('technician-note', {
    type: 'PUT',
    body: {
      service_id: jobId,
      technician_note: technicianNote, 
    },
  });

  return data;
};
